import $ from 'jquery';
import Application from './application';

export class Patches {
  public static Execute() {
    (<any>$.fn).oldSlideUp = $.fn.slideUp;
    (<any>$.fn).slideUp = function (interval, callback) {
      return (<any>$(this)).oldSlideUp(interval,
        function () {
          if (typeof (callback) == "function")
            callback();
          $(this).css('overflow', '');
        });
    };
    (<any>$.fn).oldSlideDown = $.fn.slideDown;
    (<any>$.fn).slideDown = function (interval, callback) {
      return (<any>$(this)).oldSlideDown(interval,
        function () {
          if (typeof (callback) == "function")
            callback();
          $(this).css('overflow', '');
        });
    };

    // hijack jquery's html method to run our wireups when dom is modified
    (<any>$.fn).oldHtml = $.fn.html;
    $.fn.html = function() {
      if (!arguments.length)
        return (<any>$.fn).oldHtml.apply(this, arguments);

      Application.conventionsReady = false;
      var r = (<any>$.fn).oldHtml.apply(this, arguments);
      Application.wireupConventions(this);
      Application.conventionsReady = true;
      setTimeout(Application.triggerConventionsReady, 50);

      return r;
    };

    //override jquery's replaceWith method to run our wireups when dom is modified
    (<any>$.fn).oldReplaceWith = $.fn.replaceWith;
    $.fn.replaceWith = function() {
      Application.conventionsReady = false;
      var newElement = arguments[0];
      var r = (<any>$.fn).oldReplaceWith.apply(this, arguments);
      Application.wireupConventions(newElement);
      Application.conventionsReady = true;
      setTimeout(Application.triggerConventionsReady, 50);

      return r;
    };

  }
}

